// extracted by mini-css-extract-plugin
export default {"modal":"EditBookingModal_modal__Ins9Y","submitButton":"EditBookingModal_submitButton__yeKlF","customFooter":"EditBookingModal_customFooter__blfXW"};